module.exports = __webpack_public_path__ + "img/banner4.05cb776c.jpg";